import React, { useState } from "react";
import { mdiCircleHalfFull, mdiCircleOutline, mdiCircleSlice8, mdiMoonWaningCrescent, mdiThemeLightDark, mdiWhiteBalanceSunny } from "@mdi/js";
import Main from "../../components/layout/Main";
import MdiIcon from "../../components/device/app/MdiIcon";
import { THEMES, setTheme } from "../../preferences/theme";
import { Settings } from "../../storage/store";
import "../../assets/styles/app-preferences.css";

// The app's four themes (app/screens/HomeSettings/ThemeSettings.js).
const OPTIONS = [
  { id: THEMES.SYSTEM, name: "System Default", icon: mdiThemeLightDark },
  { id: THEMES.LIGHT, name: "Light Theme", icon: mdiWhiteBalanceSunny },
  { id: THEMES.DARK, name: "Dark Theme", icon: mdiMoonWaningCrescent },
  { id: THEMES.SMART, name: "Smart Theme", icon: mdiCircleHalfFull, description: "Automatic Day / Night mode" },
];

function ThemeSettings() {
  const [themeId, setThemeId] = useState(Settings.getThemeId);

  const choose = (id) => {
    setTheme(id);
    setThemeId(id);
  };

  return (
    <Main header="stack" title="Theme Settings" hideTabBar>
      <div className="hx-pref-themes" role="radiogroup" aria-label="Theme">
        {OPTIONS.map((option) => {
          const checked = option.id === themeId;
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={checked}
              className="hx-pref-theme"
              onClick={() => choose(option.id)}
            >
              <MdiIcon path={option.icon} size={25} />
              <span className="hx-pref-theme-text">
                <span className="hx-pref-theme-name">{option.name}</span>
                {option.description ? <span className="hx-pref-theme-description">{option.description}</span> : null}
              </span>
              <MdiIcon className="hx-pref-radio" path={checked ? mdiCircleSlice8 : mdiCircleOutline} size={25} />
            </button>
          );
        })}
      </div>
    </Main>
  );
}

export default ThemeSettings;
